module.exports = __webpack_public_path__ + "images/Algorithms as Policy.pdf?v=967645474e4b52cc49b9352c789899a5";